$(document).ready(function () {
    let billingCheckbox = $('input.use_shipping_info');// чекбокс use shipping
    let billingField = $('.billing_fields');// контейнер для инпутов блока billing
    let billingInput = $('#billing_form .billing_fields input.form-control');// нпуты блока billing
    let optionalBlock = $('#delivery_form, #billing_form');// блоки billing и shipping
    let shippingInput = $('#delivery_form input.form-control');// инпуты блока shipping


    // Elements to inject
     var mySVGsToInject = document.querySelectorAll('img.js-svg-injector');
     SVGInjector(mySVGsToInject);


    billingCheckbox.on('change', function () {
        if ($(this).is(':checked')){
            billingField.slideUp(300);
            removeRequired(billingInput);
        }
        else {
            billingField.slideDown(300);
            addRequired(billingInput);
        }
    });

    $('.payment-chooser__input').on('change', function () {
        if ($('#Stripe').is(':checked')){
            optionalBlock.slideDown(300);
            addRequired(shippingInput)
        }
        else {
            optionalBlock.slideUp(300);
            removeRequired(shippingInput);
            if (billingCheckbox.is(':not(:checked)')) {
                billingCheckbox.trigger('change');
            }
        }
    });
});

function addRequired($elements) {
    $elements.attr('required', 'true');
}

function removeRequired($elements) {
    $elements.removeAttr('required');
}
